import React from 'react';
import DigestMode from '../elements/DigestionTab.Mode';
import DigestEnzyme from '../elements/DigestionTab.Enzyme';

// *** important
// Digest Mode parameters can overwrite Digest Enzyme in the backend json processing step

class DigestionTab extends React.Component{

  render(){
    // console.log(this.props);
    return (
      <div>
        <div className="parameters-subcategory-title-wrapper">
          <div>Set Digestion</div>
        </div>
        <DigestMode
          updateParameters={this.props.updateParameters}
          digestModeList={this.props.digestModeList}
          parameters={this.props.parameters} />
        <DigestEnzyme 
          updateParameters={this.props.updateParameters}
          digestEnzymeList={this.props.digestEnzymeList}
          parameters={this.props.parameters} />
      </div>
    );
  }
}

export default DigestionTab;